// extracted by mini-css-extract-plugin
export default {"container":"RecordList_container__DENtf","body":"RecordList_body__oT+47"};